import Checkbox, {
  Checkbox as CheckboxBase
} from '@material/react-checkbox';
import './Checkbox.scss';

/**
 * Checkbox MCWR Component
 *
 * @version ./package.json
 */
export default Checkbox;

export {
  CheckboxBase,
};
